import styled, { css } from 'styled-components'

import { LinkSecondaryButton } from '../../../../../../global/LinkButton'

import EscriptIconSvg from '../../../../../../../img/rewards/escript.inline.svg'
import EscriptButtonIconSvg from '../../../../../../../img/rewards/escript-protocol.inline.svg'
import PersonButtonIconSvg from '../../../../../../../img/rewards/order-now.inline.svg'
import PersonIconSvg from '../../../../../../../img/rewards/person.inline.svg'
import PromoteDispensaryIconSvg from '../../../../../../../img/rewards/promote-dispensary.inline.svg'
import PromoteDispensaryButtonIconSvg from '../../../../../../../img/rewards/share-dispensary.inline.svg'

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 16px;
  background-color: #ffffff66;
  padding: 24px;
  border-radius: 8px;
  justify-content: space-between;
  flex-grow: 1;
  flex-basis: 0;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const iconsStyles = css`
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  stroke: currentColor;
  path {
    stroke: currentColor;
  }
`
export const PromoteDispensaryIcon = styled(PromoteDispensaryIconSvg)`
  ${iconsStyles};
`
export const PersonIcon = styled(PersonIconSvg)`
  ${iconsStyles};
`
export const EscriptIcon = styled(EscriptIconSvg)`
  ${iconsStyles};
`

const buttonIconStyles = css`
  width: 16px;
  height: 16px;
  margin-right: 4px;
  vertical-align: sub;
  stroke: currentColor;
  path {
    stroke: currentColor;
  }
`
export const EscriptButtonIcon = styled(EscriptButtonIconSvg)`
  ${buttonIconStyles};
`
export const PersonButtonIcon = styled(PersonButtonIconSvg)`
  ${buttonIconStyles};
`
export const PromoteDispensaryButtonIcon = styled(PromoteDispensaryButtonIconSvg)`
  ${buttonIconStyles};
`

export const Title = styled.h3`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: bold;
  margin: 0;
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
`

export const Description = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  flex-grow: 1;
`

export const Footer = styled.div``

export const LinkButton = styled(LinkSecondaryButton)`
  font-size: 16px;
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  padding: 8px 16px;
  text-transform: none;
  color: ${({ theme }) => theme.colors.brand.blue};
  background-color: ${({ theme }) => theme.colors.component.SecondaryButton.default.background};
  border: ${(props) => `1px solid ${props.theme.colors.brand.blue}`};
  min-height: 36px;
  border-radius: 8px;
  line-height: 19px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.component.SecondaryButton.hover.background};
    color: ${({ theme }) => theme.colors.component.SecondaryButton.hover.text};
  }

  @media (min-width: 1280px) {
    line-height: 20px;
  }
`
